import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import { I18n } from 'react-redux-i18n-lite';
import * as taskActions from '../../../actions/taskActions';
import { ChipsList } from '../../common/chipsList/ChipsList';
import { format } from 'date-fns';

const FILTER_TYPE = {
  DATES: 'dates',
  KEYWORDS: 'keywords'
};

export const AssignmentsChipsList = ({ datesFilter, keywordsFilter, tasksActions }) => {
  const removeActualFilter = filter => {
    if (filter.filterType === FILTER_TYPE.DATES) {
      tasksActions.setTasksDatesRangeFilter();
    } else if (filter.filterType === FILTER_TYPE.KEYWORDS) {
      tasksActions.setTasksKeywordsFilter();
    }
  };

  const getChips = () => {
    let chips = [];
    if (keywordsFilter) {
      chips.push({ name: keywordsFilter, filterType: FILTER_TYPE.KEYWORDS });
    }
    if (datesFilter && !_.isNil(datesFilter.startDate) && !_.isNil(datesFilter.endDate)) {
      let name = `${format(datesFilter.startDate, 'dd/MM/yyyy')} - ${format(datesFilter.endDate, 'dd/MM/yyyy')}`;
      chips.push({ name, filterType: FILTER_TYPE.DATES });
    }
    return chips;
  };

  const getTitle = () => {
    const datesFilterApplied = datesFilter && !_.isNil(datesFilter.startDate) && !_.isNil(datesFilter.endDate);
    if (keywordsFilter || datesFilterApplied) {
      return <span className="chip-list-title">{I18n.t('common.appliedFilters')}</span>;
    }
  };

  return (
    <div className="assignments-chip-list">
      {getTitle()}
      <ChipsList items={getChips()} removeChip={removeActualFilter} />
    </div>
  );
};

AssignmentsChipsList.propTypes = {
  datesFilter: PropTypes.object,
  keywordsFilter: PropTypes.string,
  tasksActions: PropTypes.object
};

function mapStateToProps(state) {
  return {
    datesFilter: state.task.datesRangeFilter,
    keywordsFilter: state.task.keywordsFilter
  };
}

function mapDispatchToProps(dispatch) {
  return {
    tasksActions: bindActionCreators(taskActions, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsChipsList);
